module.exports = __webpack_public_path__ + "static/norker-e9e05e1637aa6cbf750e1c35c6a3acf2.jpeg";